import { Box, Grid, Typography } from '@mui/material';
import { EligibleInstitutes, EligiblePrograms, EligibleScholarships } from '../../../../assets/illustration';
import { EligibilityItemCard } from './EligibilityItemCard';

export const EligibilitySection: React.FC = () => {
  return (
    <Box className="container-fluid" sx={{ py: 5 }}>
      <Box sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 3, bgcolor: 'warning.light' }}>
        <Typography variant="h4" align="center" component="h2" sx={{ maxWidth: '45rem', p: 3, mx: 'auto' }}>
          Find eligible programs, scholarships and institutions for you
        </Typography>
        <Box sx={{ bgcolor: 'primary.dark', p: 3 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <EligibilityItemCard
                content="Find eligible programs based on your education details"
                buttonLabel="Find eligible programs"
                Illustration={EligiblePrograms}
                module="Programs"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <EligibilityItemCard
                content="Find eligible institutions based on your education details"
                buttonLabel="Find eligible institutions"
                Illustration={EligibleInstitutes}
                module="Institutes"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <EligibilityItemCard
                content="Find eligible scholarships based on your education details"
                buttonLabel="Find eligible scholarships"
                Illustration={EligibleScholarships}
                module="Scholarships"
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};
